import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=7a27b3bd&scoped=true&"
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"
import style0 from "./vip.vue?vue&type=style&index=0&id=7a27b3bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a27b3bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a27b3bd')) {
      api.createRecord('7a27b3bd', component.options)
    } else {
      api.reload('7a27b3bd', component.options)
    }
    module.hot.accept("./vip.vue?vue&type=template&id=7a27b3bd&scoped=true&", function () {
      api.rerender('7a27b3bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event/components/vip.vue"
export default component.exports